import { useEffect } from 'react';

import { storeCashBackUserId } from '@shared/data-access-frontend/cash-back-user-id';
import { useSearchParams } from 'react-router';

export function useStoreCashBackUserId() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const cashBackUserId = searchParams.get('cashback_user_id');
    if (cashBackUserId) {
      storeCashBackUserId(cashBackUserId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
